import { useState, useCallback } from 'react'
import { Suspense } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Sidebar } from '@/components/project/Sidebar'
import { Topbar } from '@/components/project/Topbar'
import { UploadTray } from '@/modules/upload/UploadTray'
import { FloatingDocHint } from '@/components/docs/DocHint'
import { useAuth } from '@/modules/auth/AuthContext'

export function Layout() {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [collapsed, setCollapsed] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleLogout = useCallback(() => {
    logout()
    navigate('/login', { replace: true })
  }, [logout, navigate])

  return (
    <div className="flex h-dvh overflow-hidden">
<Sidebar
  collapsed={collapsed}
  mobileOpen={mobileOpen}
  onMobileClose={() => setMobileOpen(false)}
/>
      <div className="flex flex-col flex-1 min-w-0">
        <Topbar
          onMenuClick={() => setCollapsed(!collapsed)}
          onMobileMenuClick={() => setMobileOpen(true)}
          sidebarCollapsed={collapsed}
          onLogout={handleLogout}
        />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 animate-fade-in">
          <Suspense fallback={<div className="flex items-center justify-center h-full"><div className="w-5 h-5 rounded-full border-2 border-accent border-t-transparent animate-spin" /></div>}>
            <Outlet />
          </Suspense>
          <FloatingDocHint />
        </main>
      </div>
      <UploadTray />
    </div>
  )
}
